module.exports = __webpack_public_path__ + "img/VA.5a98ece5.png";